export class DatabaseDestination {
    'awsRds';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "awsRds",
            "baseName": "awsRds",
            "type": "AwsDatabaseDestination",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DatabaseDestination.attributeTypeMap;
    }
    constructor() {
    }
}
